import { useMutation } from '@tanstack/react-query';

import { CashFlowApi } from '../cashFlow.api';

export const useGetCashReceivedFromCustomerCalculation = () => {
  return useMutation({
    mutationFn: CashFlowApi.getCashReceivedFromCustomerCalculation,
  });
};
